import { MessageSquare } from 'lucide-react'
import { Button } from '@/shared/ui/primitives'
import { useFeedbackDialogContext } from '../providers'

export function FeedbackTriggerButton() {
  const { openDialog } = useFeedbackDialogContext()

  return (
    <Button variant="outline" onClick={openDialog}>
      <MessageSquare className="size-4" />
      Share Feedback
    </Button>
  )
}
